import React, { useMemo } from 'react';
import { isBarGraphEmpty } from '../../../../../chart/utils/eventBarGraph';
import ActivationStatsTooltip from './ActivationStatsToolTip';
import { BarVariant, IStackedBarPoints } from '../../../../../chart/interfaces/barGraph';
import { GraphComponent } from '../../../../../chart/components/bar-graph/BarGraph';

interface ActivationBarGraphProps {
  boxHeight: number;
  noOfBars: number;
  barWidth?: number;
  barsSpacing?: number;
  points: IStackedBarPoints;
}

export default function ActivationBarGraph({
   boxHeight,
   noOfBars,
   barWidth = 5,
   barsSpacing = 2,
   points
}: ActivationBarGraphProps) {

  const boxWidth = useMemo(() => {
    return noOfBars * (barWidth + barsSpacing) + barWidth;
  }, [noOfBars, barWidth, barsSpacing]);

  const isEmpty = useMemo(() => isBarGraphEmpty(points), [points]);

  return (
    <GraphComponent
      data={points}
      graphWidth={boxWidth}
      graphHeight={boxHeight}
      barsSpacing={barsSpacing}
      barWidth={barWidth}
      isEmpty={isEmpty}
      emptyBarCount={noOfBars}
      barVariant={BarVariant.STACKED}
      ToolTipComponent={ActivateBarTooltipContent}
      stackedVariantColors={['error', 'primary']}
    />
  );
}

export function ActivateBarTooltipContent({ data }) {
  return (
    <ActivationStatsTooltip
      dataPoint={data?.dataPoint}
      runStageInfo={data?.stageInfo}
    />
  );
}
